/**
 * сайт TAS
 */
import { BitrixVue, reactive } from 'ui.vue3';
import './tas-account.css';
import { createPinia } from 'ui.vue3.pinia';
import { VplRouter } from './services/vpl-router/vpl-router';
import { Header } from './components/header/header';
import { App } from './components/app/app';
import { Footer } from './components/footer/footer';

import { hidePreloader } from './services/preloader/preloader';
import { initLkBillNotice } from './services/lk-bill-notice/lk-bill-notice';
import { initCopyGoals, initMessengerGoals, initAttribution } from './services/analytics/analytics';

// атрибуция первого касания (cookie tas_attr) — до любых форм и заказов
initAttribution();

//обработка перехода к предыдущей странице
window.onpopstate = function (event) {

    if(window.fancyPopBack){
        window.fancyPopBack = false;
        return;
    }

    const state = event.state;
    let route = window.location.href;
    let scrollTop = null;

    if(typeof state === 'string' && state){
        route = state;
    }else if(state && typeof state === 'object'){

        if(typeof state.url === 'string' && state.url){
            route = state.url;
        }

        if(typeof state.scrollTop === 'number' && Number.isFinite(state.scrollTop)){
            scrollTop = state.scrollTop;
        }
    }

    VplRouter(
        route,
        false,
        true,
        false,
        function(){

            if(scrollTop === null){
                return;
            }

            window.requestAnimationFrame(function(){
                window.requestAnimationFrame(function(){
                    window.scrollTo({
                        top: scrollTop,
                        left: 0,
                        behavior: 'auto'
                    });
                });
            });
        }
    );
};

window.onload = () => {

	//удаление ошибок при взаимодействии с инпутами
	document.body.addEventListener('input', function(event) {
		if (event.target.matches('.is-error input, .is-error textarea')) {
			event.target.closest('.is-error').classList.remove('is-error');
		}
	});
	document.body.addEventListener('click', function(event) {
		if (event.target.matches('.is-error input, .is-error textarea')) {
			event.target.closest('.is-error').classList.remove('is-error');
		}
	});
	document.body.addEventListener('change', function(event) {
		if (event.target.matches('.is-error input, .is-error textarea')) {
			event.target.closest('.is-error').classList.remove('is-error');
		}
	});

	//делегирование кликов по ссылкам
	document.body.addEventListener('click', function(e){

        // SAIT-86: делегированный обработчик нужен, потому что блоки главной
        // пересоздаются при SPA-переходах.
        const equipmentShowButton = e.target.closest('.js-equipment-show-about');

        if (equipmentShowButton) {
            e.preventDefault();

            const container = equipmentShowButton.closest('.container');
            const list = container
                ? container.querySelector('.js-equipment-list-about')
                : null;

            if (!list) {
                return;
            }

            const isShow = !equipmentShowButton.classList.contains('is-show');

            equipmentShowButton.classList.toggle('is-show', isShow);
            equipmentShowButton.textContent = isShow ? 'Свернуть' : 'Показать ещё';
            list.classList.toggle('is-show', isShow);

            if (!isShow) {
                $('html').animate({
                    scrollTop: $(list).offset().top - 150
                }, 500);
            }

            return;
        }

		//для определенных директорий не используем SPA переходы
		//это нужно для работы дефолтных скриптов компонентов
		if(!window.nospa || !window.nospa.includes(window.location.pathname)){

			let link = false, isTrigger = false, doScroll = true, blank = false;

			let path = e.composedPath ? e.composedPath() : e.path;

			path.forEach( item => {
				if($(item).prop('target') == '_blank'){
					blank = true;
					return false;
				}
				if(item.tagName === 'A'){
					link = item.getAttribute('href');
					doScroll = ($(item).data('scroll') == 'no' ? false : true);
					isTrigger = ( $(item).data('skip') == 'y' || link == '#' ? true : false );
				}
				if($(item).data('fancybox')){
					isTrigger = true;
				}
			});

			if(blank){
				return;
			}

			if (link && link !== false && !link.includes("/bitrix/admin/")) {

				if(link[0] == '#' && link != '#'){
					//якорь на странице
					if($(link).length){
						$([document.documentElement, document.body]).animate({
							scrollTop: $(link).offset().top
						}, 500);
					}
				}else{
					if(isTrigger){
						e.preventDefault();
					}else{
						VplRouter(link, e, false, doScroll);
					}
				}
			}
		}

	});
/*
	document.addEventListener('scroll', function() {
		let elemNav = document.getElementById('about-nav');
		if(elemNav){
			const posTop = elemNav.getBoundingClientRect().top;
			elemNav.classList.toggle('is-fixed', posTop <= 0);
		}
	}, {passive: true});
*/
	const appStore = createPinia();

	const vplHeader = BitrixVue.createApp({
		components: { Header },
		template: ` <Header/> `
	}).use(appStore).mount('#header');

	//для определенных директорий не используем vue в теле страницы
	if(!window.nospa || !window.nospa.includes(window.location.pathname)){
		const vplApp = BitrixVue.createApp({
			components: { App },
			template: ` <App/> `
		}).use(appStore).mount('#app');
	}else{
		hidePreloader();
	}
/*
	const vplPanel = BitrixVue.createApp({
		components: { Panel },
		template: ` <Panel/> `
	}).use(appStore).mount('#mpanel');
*/

	const vplFooter = BitrixVue.createApp({
		components: { Footer },
		template: ` <Footer/> `
	}).use(appStore).mount('#footer');

initLkBillNotice();
initCopyGoals();
initMessengerGoals();

}

/*
 Публичный API ядра для расширений групп страниц (vpl.tas.lk, vpl.tas.catalog …,
 см. extensions.json): сборщик кладёт экспорты в BX.Vpl.*, а расширения
 импортируют их как `import { vplSiteStore } from 'vpl.tas'`. Состав менять
 только с обратной совместимостью в пределах одной выкладки: бандл группы из
 кеша браузера может встретить новое ядро.
*/
export { vplSiteStore } from './store/vplstore';
export { NewsletterHost } from './components/newsletter/newsletter-host';
export { NewsletterCheckbox } from './components/newsletter/newsletter-checkbox';
// Поиск внутри ленивого меню использует тот же плейсхолдер и набор текста.
export { SearchTrigger } from './components/search/search-trigger';
export { acquireOverlayBodyLock } from './services/overlay-body-lock';
export { VplRouter } from './services/vpl-router/vpl-router';
export * from './tools/functions';
export * from './services/preloader/preloader';
export { goal as ymGoal, hit as ymHit, ecommerce as ymEcommerce, leadGoal as ymLead, pageContext as ymPageContext, basketEvents as ymBasketEvents, productDetail as ymProductDetail } from './services/analytics/analytics';
export { EditBtns } from './services/editbtns/editbtns';
export { ItemEditBtns } from './services/itemeditbtns/itemeditbtns';
export { CatalogCard } from './components/catalog.item/catalogcard';
export { MessengerLinks } from './components/messengers/messenger-links';
export { CheckboxItem } from './components/catalog.smart.filter/checkboxitem';
export { HtmlComponent } from './components/htmlcomponent/htmlcomponent';
export { TitleBlock } from './components/header/titleblock';
export { resolveComponent, resetLazyChoices, extensionOf } from './components/app/lazy';
